import React, {useMemo} from 'react';
import lz from 'lzutf8';
import {Frame, Element} from '@craftjs/core';
import {EditorContentContainer} from 'components';

import useProjectStore from '../../stores/useProjectStore';

const DEFAULT_TEMPLATE =
  'eyJST09UIjp7InR5cGXECHJlc29sdmVkTmFtZSI6IkVkaXRvckNvbnRlbnTEB2FpbmVyIn0sImlzQ2FudmFzIjp0cnVlLCJwcm9wc8RCbW9iaWxlU3R5bMRRfSwic8cLImRpc3BsYXkiOiJmbGV4IizFB0RpcmVjdGlvbiI6ImNvbHVtbiIsImp1c3RpZnnHeCI6InNwYWNlLWJldHdlZcQhYWxpZ25JdGVtc8Q3ZW50ZXIiLCJ3aWR0aCI6IjEwMCUiLCJoZWlnaMQ+YXV0byIsImJhY2tncm91bmRDb2xvciI6InJnYmEoMjQxLDI0NSwyNDksMSkiLCJwYWRkaW5nxEk0cHggzgUiLCJtaW5IyFsxMDBkdmgifX0s6ADf5wE66gEtLCJjdXN0b23kAQNpY+UA6VNxdWFyZXMyWDJJxBEsIsUH5QEuzkZSb2905AFuaGlkZGVuIjpmYWxzZSwibm9kZXMiOlsiR1JsLWtGZkgyRiIsImxUZnYzMWtHYk8iXSwibGlua2VkTsYqe+QAoVgxQmNVakNaZS3/AfLpAfJQYXJhZ3JhcGjuAfLnAIbpAfN0ZXjkAQxBdWdt5AGLZCBSZWFsaXR5IGZvciBldmVyeW9uZSzGCndoZXJlLiLrAhdmb250U2l6xH0y5gFhxFBB5AHi7AHdY+cBtCMwxQHtAagwcHggywTkAaRhcmdpxEAt5QG6zB19LO8CpOsCmW5vbmXzAc3qAQjzAc1CYXJzM0JvdHRvbUxlZnTnAdLOQVN1YnRpdGxlxH1wYXLmAtXtAb33AeL1AclfVmpaQnV1bVf/Acn/Acn5AclTY2FuIHRoaXMgUVI8YnI+PHNwYW4g5QGxPVzrA0ct5QGUOiDpA0cg5ANIIOQDSSAwKTtcIj5mcm9tIOYBbiBwaG9uZSB0byBzdGFydDwvxFU+9wIJMTj/AgkiOiJibGFja/8Dr+0CCzLwAif/Agr/Agr/Agr4AgpjYW5U5AFn/wIK/wIK5wIKMnlfTVlsZ1lrNP8CCv8CCvgCCnBvd2VyZWQgYnn4Aan/A7L5A7IgxQLzAYPMXTXkAaX/AYT/AYTEFuwBa+sFJf8Ba+8Ba2h5Q1NHVnNnbzX/AWv/AWv4AWtEYXNBUvgFGOYE1f4BZjM0YmM3OP8BZthd/wFm/wFm/wFm/wFm7AFm6wMK/wFm/wiW/QiW7AQ0MOQEDjPNBcRK/wi2/wi25gEGxCot5QTu/wiz6Qiz/wij5AVaMO8IozboALo05AT0xAr/CI7/CI7xBLLoANDsAeDlCjf6CJdWcmluMjkzdFpLIu0IdywiSWcwazBxcm9m5AmR6wbILCJkTHF3X2hpU19QIiwiWTVJTTFYSU5RSSIsInVOeU1FWG9Rd1P2CNjrAm3/AjT/AjT/Csr/AhT/AhT/AhT/AhT/AhTuAhTuAs7/AhT/AhT2AhRQ5gYYQnn/AhbtAhbrBq3tBU/1AdXrAgL/AdXoAdVRUv4FaOkBvvgMJ8cQbWF4V8ciM+cIiG1heOsL8jjmBY7yAZh3aGl0ZcQab3JkZXJSYWRpdeQB2THGMOwEdOQIns0FxTZ4U2hhZG935QW55APN5APbLTFweOQJYSjmBcwvIDAuMSksIDAgMuQD88QhxAnQIe0I9/8LAesBEjnnAQHHOjHEW8068QJFUVJDb2TkAPTxAkJRcsQa8QYa/wjr+gYa6wQ6/wIR/weA9weAPGI+VGFwIFwiQWxsb3dcIuQKqmFjY2VzcyBBUjwvYvgKq/MMtGxlZuQD3voKqegHmOsBbMoT8AqE+wqlYmxvxVryCCvKWPENG/oNN/8IBf8IBf8B6/8B6+wB6+sGC/8B6/8B6/8OqekOqf8M5f8M5fkO5v4M5P8O7f8CO/8CO/8CO/UCO+kE7fkEOf8CIP8CIP8CIP8CIOsCIOsIX/8CIP8CIPoEC+ULjvsD9uUKN/4D9+UCMTUyLDE4OCwxMjDwElz7Acn9C683MtF55wI3/wGf/wGf9QfoVP8Qtf8BtewBtesJxv8BtegBtUxhdW5jaPAJpfABtGFzc2lnbmVkTWVzaMh+6QGy6AGM6Aea5AFIV+gHyjXlDpTyB8fkDUpi5Q1K7wfJ5QlJ7QfJ5AchM8QFyQr/AdDnAJjJI8U9/gNk6QEH8wHEUm9ja2XnASn/A2D/AavqAat9';

interface IProjectEditorProps {}

const ProjectEditor = ({}: IProjectEditorProps) => {
  const id = useProjectStore(s => s.editorRootId);
  const contentToken = useProjectStore(s => s.previewState?.contentToken);

  const data = useMemo(() => {
    const token = contentToken ?? DEFAULT_TEMPLATE;
    return lz.decompress(lz.decodeBase64(token)) as string;
  }, [contentToken]);

  return (
    <div id={id} className="relative w-full h-full">
      <Frame {...(data ? {data} : {})}>
        <Element
          is={EditorContentContainer as unknown as Element}
          canvas
          custom={{
            displayName: 'Root',
          }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: '100%',
            minHeight: '100dvh',
            backgroundColor: 'white',
            padding: '0 0 0 0',
          }}></Element>
      </Frame>
    </div>
  );
};

export default React.memo(ProjectEditor);
